<script>
import { mapActions, mapGetters } from 'vuex';
import { PAYMENT_TYPES } from '@/modules/constants';
import paypal_logo from '@/assets/images/paymethods/paypal.svg';
import klarna_logo from '@/assets/images/paymethods/klarna.svg';
import vorkasse_logo from '@/assets/images/paymethods/vorkasse.svg';
import appConfig from '@/configs/app.config';

export default {
  name: 'FormPaymentMethods',
  components: {
    paypal_logo,
    klarna_logo,
    vorkasse_logo
  },
  data() {
    return {
      PAYMENT_TYPES,
      paymentMethod: PAYMENT_TYPES.VORKASSE,
      loadingPanel: false,
      activatePayPal: true
    };
  },
  computed: {
    ...mapGetters(['formErrors', 'invoiceData', 'formData', 'prices', 'paymentMethodData', 'customer', 'tempBnr'])
  },
  mounted() {
    if (!this.formData.paymentMethod) {
      if (this.paymentMethodData) {
        this.formData['paymentMethod'] = this.paymentMethodData;
      } else {
        this.formData['paymentMethod'] = this.paymentMethod;
      }
    }

    this.loadingPanel = true;
    this.getPppTokenAction(response => {
      if (response.status) {
        let pppMode = appConfig.paypalPlusMode;
        this.$store.commit('SET_TEMP_BNR', response.bnr);
        let pppOptions = {
          approvalUrl: response.url,
          placeholder: 'ppplus',
          mode: pppMode,
          country: 'DE',
          language: 'de_DE',
          buttonLocation: 'outside',
          preselection: 'paypal',
          enableContinue: 'form-submit',
          disableContinue: 'form-submit'
        };
        if (typeof PAYPAL === 'undefined') {
          let pppInit = document.createElement('script');
          pppInit.setAttribute('src', 'https://www.paypalobjects.com/webstatic/ppplus/ppplus.min.js');
          document.head.appendChild(pppInit);
          pppInit.onload = function() {
            if (typeof PAYPAL.apps.PPP !== 'undefined') {
              PAYPAL.apps.PPP(pppOptions);
            }
          };
        } else {
          PAYPAL.apps.PPP(pppOptions);
        }
      } else {
        this.activatePayPal = false;
      }
      this.loadingPanel = false;
    });
  },
  methods: {
    ...mapActions(['setFormSubmittedAction', 'updateFormDataAction', 'setFormDataAction', 'getPppTokenAction']),

    handleSubmit1: function() {
      //console.log('clicked to send');
      if (!this.formData.paymentMethod) {
        this.updateFormDataAction({
          paymentMethod: PAYMENT_TYPES.VORKASSE
        });
      }

      this.setFormSubmittedAction(true);

      if (this.formErrors.firstForm && this.formErrors.formInvoice) {
        if (this.formData.secondFormEnabled) {
          if (!this.formErrors.secondForm || this.formData.secondForm.zipCode === '') {
            return;
          }
        }

        this.$store.commit('SET_NEXT_STEP', 3);
      }
    },
    enableFormButton: function() {
      document.getElementById('form-submit').removeAttribute('disabled');
    }
  }
};
</script>
<style scoped>
.payment-paypal-logo {
  width: 150px;
  max-width: 100% !important;
}
.payment-klarna-logo {
  width: 150px;
  max-width: 100% !important;
}
.payment-vorkasse-logo {
  width: 175px;
  max-width: 100% !important;
  fill: #000000 !important;
}
.loading-panel {
  position: absolute;
  top: 10px;
  left: 0;
  background-color: #494949;
  width: 100%;
  height: 100%;
  opacity: 0.75;
  z-index: 99;
}
.loading-panel-spinner {
  display: table;
  position: relative;
  margin: 0 auto;
  top: calc(50% - 24px);
  color: #ffffff !important;
}
</style>
<template>
  <div class="form-details-payment-methods">
    <div class="col-md-3">
      <div class="panel panel-default panel-hv-grey">
        <div class="panel-heading" v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
          <div><i class="fa fa-eur"></i></div>
          3. Bezahlmöglichkeiten:
        </div>
        <div class="panel-body pt-lg-25 pt-md-25" style="position:relative;">
          <div class="loading-panel" v-show="this.loadingPanel">
            <span class="loading-panel-spinner fa fa-spinner fa-spin fa-3x"></span>
          </div>
          <form id="vwo-hv-form-form-payment" @submit.prevent>
            <div v-show="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
              <div v-if="customer && customer.zahlungsart === PAYMENT_TYPES.EINZUG" class="width-100 mb-15 hv-payment">
                <div class="col-xs-1 p-0" style="top: 1px !important;">
                  <input
                    :checked="formData.paymentMethod === PAYMENT_TYPES.EINZUG"
                    v-on:click="paymentMethod = PAYMENT_TYPES.EINZUG"
                    @change="
                      updateFormDataAction({
                        paymentMethod: paymentMethod
                      });
                      enableFormButton();
                    "
                    type="radio"
                    value="Einzugsermächtigung"
                    name="bezahlung"
                    id="einzugsermachtigung"
                  />
                </div>
                <div class="col-xs-11 pr-0">
                  <label for="einzugsermachtigung" class="inline">Einzugsermächtigung</label>
                </div>
                <div class="clear"></div>

                <div id="inputs_lastschrift" style="margin-top: 5px;">
                  <div class="width-100">
                    <div class="half_responsive responsive_label">
                      <label>Kontoinhaber:</label>
                    </div>
                    <div class="half_responsive">
                      <input
                        class="form-control width-100"
                        name="konto_inhaber"
                        type="text"
                        readonly="readonly"
                        :value="customer.konto_inhaber"
                      />
                    </div>
                  </div>
                  <div class="width-100">
                    <div class="half_responsive responsive_label">
                      <label>Bankname:</label>
                    </div>
                    <div class="half_responsive">
                      <input
                        class="form-control width-100"
                        name="bankname"
                        type="text"
                        readonly="readonly"
                        :value="customer.bankname"
                      />
                    </div>
                  </div>
                  <div class="width-100">
                    <div class="half_responsive responsive_label">
                      <label>IBAN:</label>
                    </div>
                    <div class="half_responsive">
                      <input
                        class="form-control width-100"
                        name="kontonummer"
                        type="text"
                        readonly="readonly"
                        :value="customer.kontonummer"
                      />
                    </div>
                  </div>
                  <div class="width-100">
                    <div class="half_responsive responsive_label">
                      <label>BIC:</label>
                    </div>
                    <div class="half_responsive">
                      <input
                        class="form-control width-100"
                        name="blz"
                        type="text"
                        readonly="readonly"
                        :value="customer.blz"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-show="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)"
              class="width-100 mb-15 hv-payment "
            >
              <div class="col-xs-1 p-0">
                <input
                  required=""
                  :checked="formData.paymentMethod === PAYMENT_TYPES.VORKASSE"
                  v-on:click="paymentMethod = PAYMENT_TYPES.VORKASSE"
                  @change="
                    updateFormDataAction({
                      paymentMethod: paymentMethod
                    });
                    enableFormButton();
                  "
                  type="radio"
                  value="Überweisung"
                  name="bezahlung"
                  id="vorkasse"
                />
              </div>
              <div class="col-xs-11 pr-0">
                <label for="vorkasse" class="inline">
                  <vorkasse_logo class="payment-vorkasse-logo" />
                </label>
              </div>
              <div class="clear"></div>
            </div>

            <!--          <div v-show="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)" class="width-100 mb-15 hv-payment">
            <div class="col-xs-1 p-0" style="top: 9px !important;">
              <input
                :checked="formData.paymentMethod === PAYMENT_TYPES.KLARNA"
                v-on:click="paymentMethod = PAYMENT_TYPES.KLARNA"
                @change="
                  updateFormDataAction({
                    paymentMethod: paymentMethod
                  });
                  enableFormButton();
                "
                type="radio"
                value="Sofortüberweisung"
                id="sofort_uberweisung"
                name="bezahlung"
              />
            </div>
            <div class="col-xs-11 pr-0">
              <label for="sofort_uberweisung" class="inline">
                <klarna_logo class="payment-klarna-logo" />
              </label>
              <br />
              <span v-if="prices.total" style="font-size: 12px;">Zzgl. <strong>{{ this.calculateKlarnaFee(prices) | customMoneyFormat }}</strong> € Klarna Gebühren.</span>
            </div>
            <div class="clear"></div>
          </div>-->

            <div v-show="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)" class="width-100 mb-15">
              <div v-show="this.activatePayPal">
                <div class="col-xs-1 p-0" style="top: 9px !important;">
                  <input
                    :checked="formData.paymentMethod === PAYMENT_TYPES.PAYPAL"
                    v-on:click="paymentMethod = PAYMENT_TYPES.PAYPAL"
                    @change="
                      updateFormDataAction({
                        paymentMethod: paymentMethod
                      })
                    "
                    type="radio"
                    value="PayPal"
                    id="paypal"
                    name="bezahlung"
                  />
                </div>
                <div class="col-xs-11 pr-0">
                  <label for="paypal" class="inline">
                    <paypal_logo class="payment-paypal-logo" />
                  </label>
                  <span
                    v-if="formData.paymentMethod !== PAYMENT_TYPES.PAYPAL"
                    style="font-weight: bold; font-size: 14px; display: block;"
                    >Kreditkarte / Lastschrift</span
                  >
                  <span v-if="prices.total" style="font-size: 12px; display: block;"
                    >Zzgl. <strong>{{ this.calculatePaypalFee(prices) | customMoneyFormat }}</strong> € PayPal
                    Gebühren.</span
                  >
                </div>
                <div class="clear"></div>
                <div id="ppplus"></div>
              </div>
            </div>

            <div class="text-center">
              <button v-on:click="handleSubmit1" id="form-submit" name="form_send_2" class="btn btn-danger width-100">
                Zur Bestellübersicht
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
